/********************************** Body ***********************************/ 
import ZeusSkin from '../assets/new-ui/gallery/body/ZeusSkin.png'
import HadesSkin from '../assets/new-ui/gallery/body/HadesSkin.png'
import ApolloSkin from '../assets/new-ui/gallery/body/ApolloSkin.png'
import PoseidonSkin from '../assets/new-ui/gallery/body/PoseidonSkin.png'
import HephaestusSkin from '../assets/new-ui/gallery/body/HephaestusSkin.png'
import AphroditeSkin from '../assets/new-ui/gallery/body/AphroditeSkin.png'
import HermesSkin from '../assets/new-ui/gallery/body/HermesSkin.png'
import AresSkin from '../assets/new-ui/gallery/body/AresSkin.png'
import AthenaSkin from '../assets/new-ui/gallery/body/AthenaSkin.png'
import CosmicEnergy from '../assets/new-ui/gallery/body/CosmicEnergy.png'
import IceEnergy from '../assets/new-ui/gallery/body/IceEnergy.png'
import NebulaEnergy from '../assets/new-ui/gallery/body/NebulaEnergy.png'
import SteelEnergy from '../assets/new-ui/gallery/body/SteelEnergy.png'
import WaterEnergy from '../assets/new-ui/gallery/body/WaterEnergy.png'
import FairyEnergy from '../assets/new-ui/gallery/body/FairyEnergy.png'
import GhostEnergy from '../assets/new-ui/gallery/body/GhostEnergy.png'
import FireEnergy from '../assets/new-ui/gallery/body/FireEnergy.png'
import DarkEnergy from '../assets/new-ui/gallery/body/DarkEnergy.png'
import GrassEnergy from '../assets/new-ui/gallery/body/GrassEnergy.png'
import PoisonEnergy from '../assets/new-ui/gallery/body/PoisonEnergy.png'
import RockEnergy from '../assets/new-ui/gallery/body/RockEnergy.png'
import HollowEnergy from '../assets/new-ui/gallery/body/HollowEnergy.png'
import LightningEnergy from '../assets/new-ui/gallery/body/LightningEnergy.png'
import PrismEnergy from '../assets/new-ui/gallery/body/PrismEnergy.png'
import Metal from '../assets/new-ui/gallery/body/Metal.png'
import Bronze from '../assets/new-ui/gallery/body/Bronze.png'
import Gold from '../assets/new-ui/gallery/body/Gold.png'
import Silver from '../assets/new-ui/gallery/body/Silver.png'
import Franken from '../assets/new-ui/gallery/body/Franken.png'
import Vampire from '../assets/new-ui/gallery/body/Vampire.png'
import Zombie from '../assets/new-ui/gallery/body/Zombie.png'
import Tiger from '../assets/new-ui/gallery/body/Tiger.png'
import Dragon from '../assets/new-ui/gallery/body/Dragon.png'
import Zebra from '../assets/new-ui/gallery/body/Zebra.png'
import BumbleBee from '../assets/new-ui/gallery/body/BumbleBee.png'
import Denim from '../assets/new-ui/gallery/body/Denim.png'
import Cyborg from '../assets/new-ui/gallery/body/Cyborg.png'
import GreenAvocado from '../assets/new-ui/gallery/body/GreenAvocado.png'
import LimeGreen from '../assets/new-ui/gallery/body/LimeGreen.png'
import LightPurple from '../assets/new-ui/gallery/body/LightPurple.png'
import Yellow from '../assets/new-ui/gallery/body/Yellow.png'
import Tangerine from '../assets/new-ui/gallery/body/Tangerine.png'
import LightPink from '../assets/new-ui/gallery/body/LightPink.png'
import NeonPink from '../assets/new-ui/gallery/body/NeonPink.png'
import Tanned from '../assets/new-ui/gallery/body/Tanned.png'
import AppleRed from '../assets/new-ui/gallery/body/AppleRed.png'
import Brown from '../assets/new-ui/gallery/body/Brown.png'
import Blue from '../assets/new-ui/gallery/body/Blue.png'
import LightBlue from '../assets/new-ui/gallery/body/LightBlue.png'
import Basic from '../assets/new-ui/gallery/body/Basic.png'

/********************************** Accessories ***********************************/ 
import Chain from '../assets/new-ui/gallery/accessories/Chain.png'
import FangedInjury from '../assets/new-ui/gallery/accessories/FangedInjury.png'
import RainDoll from '../assets/new-ui/gallery/accessories/RainDoll.png'
import FinonFire from '../assets/new-ui/gallery/accessories/FinonFire.png'
import RainDoll2 from '../assets/new-ui/gallery/accessories/RainDoll2.png'
import Starfall from '../assets/new-ui/gallery/accessories/Starfall.png'
import Bandage from '../assets/new-ui/gallery/accessories/Bandage.png'
import Snake from '../assets/new-ui/gallery/accessories/Snake.png'
import Scars from '../assets/new-ui/gallery/accessories/Scars.png'
import ShinyPearls from '../assets/new-ui/gallery/accessories/ShinyPearls.png'
import SilverRings from '../assets/new-ui/gallery/accessories/SilverRings.png'
import BasicGoldRing from '../assets/new-ui/gallery/accessories/BasicGoldRing.png'
import Seaweed from '../assets/new-ui/gallery/accessories/Seaweed.png'
import PunkFin from '../assets/new-ui/gallery/accessories/PunkFin.png'
import None from '../assets/new-ui/gallery/accessories/None.png'

/********************************** Headware ***********************************/ 
import PoseidonCrown from '../assets/new-ui/gallery/headware/PoseidonCrown.png'
import HadesFlamingHair from '../assets/new-ui/gallery/headware/HadesFlamingHair.png'
import AphroditeFloralWreath from '../assets/new-ui/gallery/headware/AphroditeFloralWreath.png'
import ApolloLyreCrown from '../assets/new-ui/gallery/headware/ApolloLyreCrown.png'
import HephaestusBlacksmithHeadBand from '../assets/new-ui/gallery/headware/HephaestusBlacksmithHeadBand.png'
import ZeusLaurelWreath from '../assets/new-ui/gallery/headware/ZeusLaurelWreath.png'
import AresSpartanHelmet from '../assets/new-ui/gallery/headware/AresSpartanHelmet.png'
import AthenaCorinthianHelmet from '../assets/new-ui/gallery/headware/AthenaCorinthianHelmet.png'
import HermesWingedHelmet from '../assets/new-ui/gallery/headware/HermesWingedHelmet.png'
import Angel from '../assets/new-ui/gallery/headware/Angel.png'
import BirdNest from '../assets/new-ui/gallery/headware/BirdNest.png'
import Headphone from '../assets/new-ui/gallery/headware/Headphone.png'
import MonkeyHeadwear from '../assets/new-ui/gallery/headware/MonkeyHeadwear.png'
import BeastHeadband from '../assets/new-ui/gallery/headware/BeastHeadband.png'
import NonLa from '../assets/new-ui/gallery/headware/NonLa.png'
import RamenCap from '../assets/new-ui/gallery/headware/RamenCap.png'
import Pilot from '../assets/new-ui/gallery/headware/Pilot.png'
import MickeyHeadband from '../assets/new-ui/gallery/headware/MickeyHeadband.png'
import DemonHeadband from '../assets/new-ui/gallery/headware/DemonHeadband.png'
import UFO from '../assets/new-ui/gallery/headware/UFO.png'
import NativeAmericans from '../assets/new-ui/gallery/headware/NativeAmericans.png'
import Pinwheel from '../assets/new-ui/gallery/headware/Pinwheel.png'
import FrogHeadband from '../assets/new-ui/gallery/headware/FrogHeadband.png'
import Turban from '../assets/new-ui/gallery/headware/Turban.png'
import SpaHead from '../assets/new-ui/gallery/headware/SpaHead.png'
import BunnyHeadband from '../assets/new-ui/gallery/headware/BunnyHeadband.png'
import ChickHat from '../assets/new-ui/gallery/headware/ChickHat.png'
import PirateHat from '../assets/new-ui/gallery/headware/PirateHat.png'
import RedHood from '../assets/new-ui/gallery/headware/RedHood.png'
import ClownHat from '../assets/new-ui/gallery/headware/ClownHat.png'
import Medusa from '../assets/new-ui/gallery/headware/Medusa.png'
import NurseHat from '../assets/new-ui/gallery/headware/NurseHat.png'
import WizardHat from '../assets/new-ui/gallery/headware/WizardHat.png'
import Braids from '../assets/new-ui/gallery/headware/Braids.png'
import VikingHelmet from '../assets/new-ui/gallery/headware/VikingHelmet.png'
import MusketeerHat from '../assets/new-ui/gallery/headware/MusketeerHat.png'
import BirthdayHat from '../assets/new-ui/gallery/headware/BirthdayHat.png'
import DaisyWreath from '../assets/new-ui/gallery/headware/DaisyWreath.png'
import ChefHat from '../assets/new-ui/gallery/headware/ChefHat.png'
import WinterHat from '../assets/new-ui/gallery/headware/WinterHat.png'
import KingsCrown from '../assets/new-ui/gallery/headware/KingsCrown.png'
import SherlockHolmesHat from '../assets/new-ui/gallery/headware/SherlockHolmesHat.png'
import RobinHat from '../assets/new-ui/gallery/headware/RobinHat.png'
import SantaHat from '../assets/new-ui/gallery/headware/SantaHat.png'
import GoldCap from '../assets/new-ui/gallery/headware/GoldCap.png'
import SheriffsHat from '../assets/new-ui/gallery/headware/SheriffsHat.png'
import Beret from '../assets/new-ui/gallery/headware/Beret.png'
import YellowBucket from '../assets/new-ui/gallery/headware/YellowBucket.png'
import GreenBucket from '../assets/new-ui/gallery/headware/GreenBucket.png'
import RedCap from '../assets/new-ui/gallery/headware/RedCap.png'
import FloweryRedBucket from '../assets/new-ui/gallery/headware/FloweryRedBucket.png'
import GraduationHat from '../assets/new-ui/gallery/headware/GraduationHat.png'
import MagicianHat from '../assets/new-ui/gallery/headware/MagicianHat.png'

/********************************** Necklace ***********************************/ 
import RedScarf from '../assets/new-ui/gallery/necklace/RedScarf.png'
import SilverRim from '../assets/new-ui/gallery/necklace/SilverRim.png'
import GoldRings from '../assets/new-ui/gallery/necklace/GoldRings.png'
import GoldRim from '../assets/new-ui/gallery/necklace/GoldRim.png'
import BasicChoker from '../assets/new-ui/gallery/necklace/BasicChoker.png'
import Cravat from '../assets/new-ui/gallery/necklace/Cravat.png'
import PunkChoker from '../assets/new-ui/gallery/necklace/PunkChoker.png'
import CatBell from '../assets/new-ui/gallery/necklace/CatBell.png'
import Diamond from '../assets/new-ui/gallery/necklace/Diamond.png'
import GoldLeaf from '../assets/new-ui/gallery/necklace/GoldLeaf.png'
import Bell from '../assets/new-ui/gallery/necklace/Bell.png'
import Bow from '../assets/new-ui/gallery/necklace/Bow.png'
import Cross from '../assets/new-ui/gallery/necklace/Cross.png'
import Fang from '../assets/new-ui/gallery/necklace/Fang.png'
import GoldChain from '../assets/new-ui/gallery/necklace/GoldChain.png'
import Pearls from '../assets/new-ui/gallery/necklace/Pearls.png'
import SilverChain from '../assets/new-ui/gallery/necklace/SilverChain.png'
import Sunflower from '../assets/new-ui/gallery/necklace/Sunflower.png'
import GoldenEye from '../assets/new-ui/gallery/necklace/GoldenEye.png'
import Skull from '../assets/new-ui/gallery/necklace/Skull.png'
import Heart from '../assets/new-ui/gallery/necklace/Heart.png'

/********************************** Bracelets ***********************************/ 
import ApolloWristwear from '../assets/new-ui/gallery/bracelets/ApolloWristwear.png'
import AthenaWristwear from '../assets/new-ui/gallery/bracelets/AthenaWristwear.png'
import HadesWristwear from '../assets/new-ui/gallery/bracelets/HadesWristwear.png'
import ZeusWristwear from '../assets/new-ui/gallery/bracelets/ZeusWristwear.png'
import HephaestusWristwear from '../assets/new-ui/gallery/bracelets/HephaestusWristwear.png'
import HermesWristwear from '../assets/new-ui/gallery/bracelets/HermesWristwear.png'
import PoseidonWristwear from '../assets/new-ui/gallery/bracelets/PoseidonWristwear.png'
import AphroditeWristwear from '../assets/new-ui/gallery/bracelets/AphroditeWristwear.png'
import AresWristwear from '../assets/new-ui/gallery/bracelets/AresWristwear.png'
import TechClaws from '../assets/new-ui/gallery/bracelets/TechClaws.png'
import BeastClaws from '../assets/new-ui/gallery/bracelets/BeastClaws.png'
import BoxingGloves from '../assets/new-ui/gallery/bracelets/BoxingGloves.png'
import SpikyBracelet from '../assets/new-ui/gallery/bracelets/SpikyBracelet.png'
import CheerleadingPomPom from '../assets/new-ui/gallery/bracelets/CheerleadingPomPom.png'
import CrabClaws from '../assets/new-ui/gallery/bracelets/CrabClaws.png'
import MartialArts from '../assets/new-ui/gallery/bracelets/MartialArts.png'
import HandGaltingGun from '../assets/new-ui/gallery/bracelets/HandGaltingGun.png'
import PirateHook from '../assets/new-ui/gallery/bracelets/PirateHook.png'
import WolverineClaws from '../assets/new-ui/gallery/bracelets/WolverineClaws.png'
import BasicBracelet from '../assets/new-ui/gallery/bracelets/BasicBracelet.png'
import Watch from '../assets/new-ui/gallery/bracelets/Watch.png'
import Rosery from '../assets/new-ui/gallery/bracelets/Rosery.png'

/********************************** Suit ***********************************/ 
import ZeusCostume from '../assets/new-ui/gallery/suit/ZeusCostume.png'
import HermesCostume from '../assets/new-ui/gallery/suit/HermesCostume.png'
import HephaestusCostume from '../assets/new-ui/gallery/suit/HephaestusCostume.png'
import HadesCostume from '../assets/new-ui/gallery/suit/HadesCostume.png'
import PoseidonCostume from '../assets/new-ui/gallery/suit/PoseidonCostume.png'
import AthenaCostume from '../assets/new-ui/gallery/suit/AthenaCostume.png'
import AresCostume from '../assets/new-ui/gallery/suit/AresCostume.png'
import ApolloCostume from '../assets/new-ui/gallery/suit/ApolloCostume.png'
import AphroditeCostume from '../assets/new-ui/gallery/suit/AphroditeCostume.png'
import TechSuit from '../assets/new-ui/gallery/suit/TechSuit.png'
import Oni from '../assets/new-ui/gallery/suit/Oni.png'
import Jiangshi from '../assets/new-ui/gallery/suit/Jiangshi.png'
import VampireJacket from '../assets/new-ui/gallery/suit/VampireJacket.png'
import MartialArtsUniforms from '../assets/new-ui/gallery/suit/MartialArtsUniforms.png'
import Ninja from '../assets/new-ui/gallery/suit/Ninja.png'
import Pajamas from '../assets/new-ui/gallery/suit/Pajamas.png'
import DuckyDress from '../assets/new-ui/gallery/suit/DuckyDress.png'
import Cheongsam from '../assets/new-ui/gallery/suit/Cheongsam.png'
import OfficeBlazer from '../assets/new-ui/gallery/suit/OfficeBlazer.png'
import Dungarees from '../assets/new-ui/gallery/suit/Dungarees.png'
import Mummy from '../assets/new-ui/gallery/suit/Mummy.png'
import BlackTuxedo from '../assets/new-ui/gallery/suit/BlackTuxedo.png'
import RedTuxedo from '../assets/new-ui/gallery/suit/RedTuxedo.png'
import PunkBlazer from '../assets/new-ui/gallery/suit/PunkBlazer.png'
import SakuraYukata from '../assets/new-ui/gallery/suit/SakuraYukata.png'
import BusinessSuit from '../assets/new-ui/gallery/suit/BusinessSuit.png'
import BlackHoodie from '../assets/new-ui/gallery/suit/BlackHoodie.png'
import BlueHoodie from '../assets/new-ui/gallery/suit/BlueHoodie.png'
import RedHoodie from '../assets/new-ui/gallery/suit/RedHoodie.png'
import SportUniform from '../assets/new-ui/gallery/suit/SportUniform.png'
import SwimsuitBikini from '../assets/new-ui/gallery/suit/SwimsuitBikini.png'
import SwimsuitSport from '../assets/new-ui/gallery/suit/SwimsuitSport.png'
import Caveshark from '../assets/new-ui/gallery/suit/Caveshark.png'
import YellowRaincoat from '../assets/new-ui/gallery/suit/YellowRaincoat.png'
import BluePoloShirt from '../assets/new-ui/gallery/suit/BluePoloShirt.png'
import RedPoloShirt from '../assets/new-ui/gallery/suit/RedPoloShirt.png'
import Tarzan from '../assets/new-ui/gallery/suit/Tarzan.png'
import Loincloth from '../assets/new-ui/gallery/suit/Loincloth.png'
import WhiteTShirt from '../assets/new-ui/gallery/suit/WhiteTShirt.png'
import YellowTShirt from '../assets/new-ui/gallery/suit/YellowTShirt.png'

/********************************** Glasses ***********************************/ 
import CyclopsEyeshield from '../assets/new-ui/gallery/glasses/CyclopsEyeshield.png'
import VRHeadset from '../assets/new-ui/gallery/glasses/VRHeadset.png'
import Monocle from '../assets/new-ui/gallery/glasses/Monocle.png'
import PunkSunglasses from '../assets/new-ui/gallery/glasses/PunkSunglasses.png'
import FuturisticSunglasses from '../assets/new-ui/gallery/glasses/FuturisticSunglasses.png'
import ThreeDGlasses from '../assets/new-ui/gallery/glasses/3DGlasses.png'
import ScubaEyeshield from '../assets/new-ui/gallery/glasses/ScubaEyeshield.png'
import YellowBlindfolds from '../assets/new-ui/gallery/glasses/YellowBlindfolds.png'
import PirateEyepatch from '../assets/new-ui/gallery/glasses/PirateEyepatch.png'
import PineappleSunglassed from '../assets/new-ui/gallery/glasses/PineappleSunglassed.png'
import PixelSunglasses from '../assets/new-ui/gallery/glasses/PixelSunglasses.png'
import StarSunglasses from '../assets/new-ui/gallery/glasses/StarSunglasses.png'
import DiscoGlasses from '../assets/new-ui/gallery/glasses/DiscoGlasses.png'
import HeartSunglasses from '../assets/new-ui/gallery/glasses/HeartSunglasses.png'
import IncredibleMask from '../assets/new-ui/gallery/glasses/IncredibleMask.png'
import BlindGlasses from '../assets/new-ui/gallery/glasses/BlindGlasses.png'
import HypnoGlasses from '../assets/new-ui/gallery/glasses/HypnoGlasses.png'
import SunflowerSunglasses from '../assets/new-ui/gallery/glasses/SunflowerSunglasses.png'
import ReptileEyeglasses from '../assets/new-ui/gallery/glasses/ReptileEyeglasses.png'
import CatEyeSunglasses from '../assets/new-ui/gallery/glasses/CatEyeSunglasses.png'
import WhiteSunglasses from '../assets/new-ui/gallery/glasses/WhiteSunglasses.png'
import BeachSunglasses from '../assets/new-ui/gallery/glasses/BeachSunglasses.png'
import BasicGlasses from '../assets/new-ui/gallery/glasses/BasicGlasses.png'
import NerdGlasses from '../assets/new-ui/gallery/glasses/NerdGlasses.png'

/********************************** Wings ***********************************/ 
import HadesWings from '../assets/new-ui/gallery/wings/HadesWings.png'
import PoseidonWings from '../assets/new-ui/gallery/wings/PoseidonWings.png'
import AresWings from '../assets/new-ui/gallery/wings/AresWings.png'
import ApolloWings from '../assets/new-ui/gallery/wings/ApolloWings.png'
import HermesWings from '../assets/new-ui/gallery/wings/HermesWings.png'
import AthenaWings from '../assets/new-ui/gallery/wings/AthenaWings.png'
import AphroditeWings from '../assets/new-ui/gallery/wings/AphroditeWings.png'
import HephaestusWings from '../assets/new-ui/gallery/wings/HephaestusWings.png'
import ZeusWings from '../assets/new-ui/gallery/wings/ZeusWings.png'
import DemonWings from '../assets/new-ui/gallery/wings/DemonWings.png'
import BatWings from '../assets/new-ui/gallery/wings/BatWings.png'
import DragonWings from '../assets/new-ui/gallery/wings/DragonWings.png'
import OrangeBlueFairyWings from '../assets/new-ui/gallery/wings/OrangeBlueFairyWings.png'
import WhiteBlueFairyWings from '../assets/new-ui/gallery/wings/WhiteBlueFairyWings.png'
import BlueButterfly from '../assets/new-ui/gallery/wings/BlueButterfly.png'
import YellowButterfly from '../assets/new-ui/gallery/wings/YellowButterfly.png'
import DragonflyWings from '../assets/new-ui/gallery/wings/DragonflyWings.png'
import AngelWings from '../assets/new-ui/gallery/wings/AngelWings.png'

/********************************** Weapon ***********************************/ 
import ZeusLightningBlade from '../assets/new-ui/gallery/weapon/ZeusLightningBlade.png'
import PoseidonKingTrident from '../assets/new-ui/gallery/weapon/PoseidonKingTrident.png'
import HadesHellishLamp from '../assets/new-ui/gallery/weapon/HadesHellishLamp.png'
import AresInfernoWar from '../assets/new-ui/gallery/weapon/AresInfernoWar.png'
import ApolloGoldenBow from '../assets/new-ui/gallery/weapon/ApolloGoldenBow.png'
import HermesNomadStick from '../assets/new-ui/gallery/weapon/HermesNomadStick.png'
import AthenaAmazonSpear from '../assets/new-ui/gallery/weapon/AthenaAmazonSpear.png'
import AphroditeStick from '../assets/new-ui/gallery/weapon/AphroditeStick.png'
import HephaestusForgeHammer from '../assets/new-ui/gallery/weapon/HephaestusForgeHammer.png'
import FlamingAx from '../assets/new-ui/gallery/weapon/FlamingAx.png'
import FlamingSword from '../assets/new-ui/gallery/weapon/FlamingSword.png'
import FlamingCrescentBlade from '../assets/new-ui/gallery/weapon/FlamingCrescentBlade.png'
import FlamingArrows from '../assets/new-ui/gallery/weapon/FlamingArrows.png'
import FrozenSword from '../assets/new-ui/gallery/weapon/FrozenSword.png'
import FrozenCrescentBlade from '../assets/new-ui/gallery/weapon/FrozenCrescentBlade.png'
import FrozenAx from '../assets/new-ui/gallery/weapon/FrozenAx.png'
import HellishSickle from '../assets/new-ui/gallery/weapon/HellishSickle.png'
import PoisonArrows from '../assets/new-ui/gallery/weapon/PoisonArrows.png'
import GiantAx from '../assets/new-ui/gallery/weapon/GiantAx.png'
import DualBlades from '../assets/new-ui/gallery/weapon/DualBlades.png'
import GiantShuriken from '../assets/new-ui/gallery/weapon/GiantShuriken.png'
import Kunai from '../assets/new-ui/gallery/weapon/Kunai.png'
import Scythe from '../assets/new-ui/gallery/weapon/Scythe.png'
import SpikyMace from '../assets/new-ui/gallery/weapon/SpikyMace.png'
import SteelAx from '../assets/new-ui/gallery/weapon/SteelAx.png'
import SteelCrescentBlade from '../assets/new-ui/gallery/weapon/SteelCrescentBlade.png'
import SteelSword from '../assets/new-ui/gallery/weapon/SteelSword.png'
import WoodenArrows from '../assets/new-ui/gallery/weapon/WoodenArrows.png'

/********************************** Eyes ***********************************/ 
import AphroditeEyes from '../assets/new-ui/gallery/eyes/AphroditeEyes.png'
import ApolloEyes from '../assets/new-ui/gallery/eyes/ApolloEyes.png'
import AresEyes from '../assets/new-ui/gallery/eyes/AresEyes.png'
import AthenaEyes from '../assets/new-ui/gallery/eyes/AthenaEyes.png'
import HadesEyes from '../assets/new-ui/gallery/eyes/HadesEyes.png'
import HephaestusEyes from '../assets/new-ui/gallery/eyes/HephaestusEyes.png'
import HermesEyes from '../assets/new-ui/gallery/eyes/HermesEyes.png'
import PoseidonEyes from '../assets/new-ui/gallery/eyes/PoseidonEyes.png'
import ZeusEyes from '../assets/new-ui/gallery/eyes/ZeusEyes.png'
import PossessedEyes from '../assets/new-ui/gallery/eyes/PossessedEyes.png'
import InflamedEyes from '../assets/new-ui/gallery/eyes/InflamedEyes.png'
import LazerEyes from '../assets/new-ui/gallery/eyes/LazerEyes.png'
import AlienEyes from '../assets/new-ui/gallery/eyes/AlienEyes.png'
import DiamondEyes from '../assets/new-ui/gallery/eyes/DiamondEyes.png'
import OutragedEyes from '../assets/new-ui/gallery/eyes/OutragedEyes.png'
import GreedyEyes from '../assets/new-ui/gallery/eyes/GreedyEyes.png'
import ButtonEyes from '../assets/new-ui/gallery/eyes/ButtonEyes.png'
import BeautifulEyes from '../assets/new-ui/gallery/eyes/BeautifulEyes.png'
import HeartyEyes from '../assets/new-ui/gallery/eyes/HeartyEyes.png'
import ReptileEyes from '../assets/new-ui/gallery/eyes/ReptileEyes.png'
import LollipopEyes from '../assets/new-ui/gallery/eyes/LollipopEyes.png'
import AngryEyes from '../assets/new-ui/gallery/eyes/AngryEyes.png'
import DeadEyes from '../assets/new-ui/gallery/eyes/DeadEyes.png'
import ExpressionlessEyes from '../assets/new-ui/gallery/eyes/ExpressionlessEyes.png'
import BeggingEyes from '../assets/new-ui/gallery/eyes/BeggingEyes.png'
import SleeplessEyes from '../assets/new-ui/gallery/eyes/SleeplessEyes.png'
import SkepticalEyes from '../assets/new-ui/gallery/eyes/SkepticalEyes.png'
import TearyEyes from '../assets/new-ui/gallery/eyes/TearyEyes.png'
import AnnoyedEyes from '../assets/new-ui/gallery/eyes/AnnoyedEyes.png'
import DizzyEyes from '../assets/new-ui/gallery/eyes/DizzyEyes.png'
import CrazyEyes from '../assets/new-ui/gallery/eyes/CrazyEyes.png'
import EyelashEyes from '../assets/new-ui/gallery/eyes/EyelashEyes.png'
import SadEyes from '../assets/new-ui/gallery/eyes/SadEyes.png'
import SmileyEyes from '../assets/new-ui/gallery/eyes/SmileyEyes.png'
import StupidEyes from '../assets/new-ui/gallery/eyes/StupidEyes.png'
import SurprisedEyes from '../assets/new-ui/gallery/eyes/SurprisedEyes.png'
import CloseTightEyes from '../assets/new-ui/gallery/eyes/CloseTightEyes.png'
import XXEyes from '../assets/new-ui/gallery/eyes/XXEyes.png'
import NormalEyes from '../assets/new-ui/gallery/eyes/NormalEyes.png'
import TinyEyes from '../assets/new-ui/gallery/eyes/TinyEyes.png'

/********************************** Mouth ***********************************/ 
import AresMouth from '../assets/new-ui/gallery/mouth/AresMouth.png'
import AthenaMouth from '../assets/new-ui/gallery/mouth/AthenaMouth.png'
import HadesMouth from '../assets/new-ui/gallery/mouth/HadesMouth.png'
import HephaestusMouth from '../assets/new-ui/gallery/mouth/HephaestusMouth.png'
import HermesMouth from '../assets/new-ui/gallery/mouth/HermesMouth.png'
import PoseidonMouth from '../assets/new-ui/gallery/mouth/PoseidonMouth.png'
import ZeusMouth from '../assets/new-ui/gallery/mouth/ZeusMouth.png'
import AphroditeMouth from '../assets/new-ui/gallery/mouth/AphroditeMouth.png'
import ApolloMouth from '../assets/new-ui/gallery/mouth/ApolloMouth.png'
import DroolingJaw from '../assets/new-ui/gallery/mouth/DroolingJaw.png'
import Smoking from '../assets/new-ui/gallery/mouth/Smoking.png'
import Grillz from '../assets/new-ui/gallery/mouth/Grillz.png'
import BabyJaw from '../assets/new-ui/gallery/mouth/BabyJaw.png'
import Eating from '../assets/new-ui/gallery/mouth/Eating.png'
import BubbleGum from '../assets/new-ui/gallery/mouth/BubbleGum.png'
import Braces from '../assets/new-ui/gallery/mouth/Braces.png'
import TurbanMask from '../assets/new-ui/gallery/mouth/TurbanMask.png'
import Beak from '../assets/new-ui/gallery/mouth/Beak.png'
import AftermealJaw from '../assets/new-ui/gallery/mouth/AftermealJaw.png'
import BloodyJaw from '../assets/new-ui/gallery/mouth/BloodyJaw.png'
import Meh from '../assets/new-ui/gallery/mouth/Meh.png'
import NaughtySmile from '../assets/new-ui/gallery/mouth/NaughtySmile.png'
import NastySmile from '../assets/new-ui/gallery/mouth/NastySmile.png'
import Smile from '../assets/new-ui/gallery/mouth/Smile.png'
import MustacheJaw from '../assets/new-ui/gallery/mouth/MustacheJaw.png'
import ToothlessSmile from '../assets/new-ui/gallery/mouth/ToothlessSmile.png'
import Lipstick from '../assets/new-ui/gallery/mouth/Lipstick.png'
import Surprised from '../assets/new-ui/gallery/mouth/Surprised.png'
import Sad from '../assets/new-ui/gallery/mouth/Sad.png'
import UwUSmile from '../assets/new-ui/gallery/mouth/UwUSmile.png'
import HappySmile from '../assets/new-ui/gallery/mouth/HappySmile.png'
import NormalJaw from '../assets/new-ui/gallery/mouth/NormalJaw.png'

/********************************** Tail ***********************************/ 
import HadesTail from '../assets/new-ui/gallery/tail/HadesTail.png'
import ZeusTail from '../assets/new-ui/gallery/tail/ZeusTail.png'
import ApolloTail from '../assets/new-ui/gallery/tail/ApolloTail.png'
import PoseidonTail from '../assets/new-ui/gallery/tail/PoseidonTail.png'
import HermesTail from '../assets/new-ui/gallery/tail/HermesTail.png'
import AresTail from '../assets/new-ui/gallery/tail/AresTail.png'
import AthenaTail from '../assets/new-ui/gallery/tail/AthenaTail.png'
import AphroditeTail from '../assets/new-ui/gallery/tail/AphroditeTail.png'
import HephaestusTail from '../assets/new-ui/gallery/tail/HephaestusTail.png'
import Tentacles from '../assets/new-ui/gallery/tail/Tentacles.png'
import Gumiho from '../assets/new-ui/gallery/tail/Gumiho.png'
import Ghoul from '../assets/new-ui/gallery/tail/Ghoul.png'
import ShinyMermaidTail from '../assets/new-ui/gallery/tail/ShinyMermaidTail.png'
import BumbleBeeTail from '../assets/new-ui/gallery/tail/BumbleBee.png'
import DemonicDragonTail from '../assets/new-ui/gallery/tail/DemonicDragonTail.png'
import Balloon from '../assets/new-ui/gallery/tail/Balloon.png'
import Donut from '../assets/new-ui/gallery/tail/Donut.png'
import BandageTail from '../assets/new-ui/gallery/tail/BandageTail.png'
import SnakeTail from '../assets/new-ui/gallery/tail/SnakeTail.png'
import MechaTail from '../assets/new-ui/gallery/tail/MechaTail.png'
import Diamonds from '../assets/new-ui/gallery/tail/Diamonds.png'
import GoldenRings from '../assets/new-ui/gallery/tail/GoldenRings.png'
import PunkTail from '../assets/new-ui/gallery/tail/PunkTail.png'
import StabbedTail from '../assets/new-ui/gallery/tail/StabbedTail.png'
import ChainedTail from '../assets/new-ui/gallery/tail/ChainedTail.png'

/********************************** Shoes ***********************************/ 
import PoseidonWave from '../assets/new-ui/gallery/shoes/PoseidonWave.png'
import ApolloSunBoots from '../assets/new-ui/gallery/shoes/ApolloSunBoots.png'
import AresCombatBoots from '../assets/new-ui/gallery/shoes/AresCombatBoots.png'
import HermesFlyingBoots from '../assets/new-ui/gallery/shoes/HermesFlyingBoots.png'
import AthenaCombatBoots from '../assets/new-ui/gallery/shoes/AthenaCombatBoots.png'
import AphroditeSilkRibbon from '../assets/new-ui/gallery/shoes/AphroditeSilkRibbon.png'
import HephaestusBlacksmithBoots from '../assets/new-ui/gallery/shoes/HephaestusBlacksmithBoots.png'
import ZeusFlyingNimbus from '../assets/new-ui/gallery/shoes/ZeusFlyingNimbus.png'
import HadesSkullBoots from '../assets/new-ui/gallery/shoes/HadesSkullBoots.png'
import TechBoots from '../assets/new-ui/gallery/shoes/TechBoots.png'
import PunkBoots from '../assets/new-ui/gallery/shoes/PunkBoots.png'
import RedRollerskaters from '../assets/new-ui/gallery/shoes/RedRollerskaters.png'
import BeehieSlippers from '../assets/new-ui/gallery/shoes/BeehieSlippers.png'
import BlueRollerskaters from '../assets/new-ui/gallery/shoes/BlueRollerskaters.png'
import Skateboard from '../assets/new-ui/gallery/shoes/Skateboard.png'
import KungfuLoafer from '../assets/new-ui/gallery/shoes/KungfuLoafer.png'
import MartialsArts from '../assets/new-ui/gallery/shoes/MartialsArts.png'
import Slippers from '../assets/new-ui/gallery/shoes/Slippers.png'
import WoodenClogs from '../assets/new-ui/gallery/shoes/WoodenClogs.png'
import BlackSneaker from '../assets/new-ui/gallery/shoes/BlackSneaker.png'
import RedSneaker from '../assets/new-ui/gallery/shoes/RedSneaker.png'
import DuckFeet from '../assets/new-ui/gallery/shoes/DuckFeet.png'
import WarriorSandals from '../assets/new-ui/gallery/shoes/WarriorSandals.png'
import CowboyBoots from '../assets/new-ui/gallery/shoes/CowboyBoots.png'
import RainBoots from '../assets/new-ui/gallery/shoes/RainBoots.png'
import WinterBoots from '../assets/new-ui/gallery/shoes/WinterBoots.png'

/********************************** Place ***********************************/ 
import MediterraneanSea from '../assets/new-ui/gallery/place/MediterraneanSea.png'
import OlympusPeak from '../assets/new-ui/gallery/place/OlympusPeak.png'
import Tartarus from '../assets/new-ui/gallery/place/Tartarus.png'
import PantheonTemple from '../assets/new-ui/gallery/place/PantheonTemple.png'
import Abyss from '../assets/new-ui/gallery/place/Abyss.png'
import MilotIsland from '../assets/new-ui/gallery/place/MilotIsland.png'
import DelightIsland from '../assets/new-ui/gallery/place/DelightIsland.png'
import OrtrusMountain from '../assets/new-ui/gallery/place/OrtrusMountain.png'
import DenpherTemple from '../assets/new-ui/gallery/place/DenpherTemple.png'
import Gaia from '../assets/new-ui/gallery/place/Gaia.png'
import Nile from '../assets/new-ui/gallery/place/Nile.png'
import Nin from '../assets/new-ui/gallery/place/Nin.png'
import Boxphore from '../assets/new-ui/gallery/place/Boxphore.png'
import Cyclop from '../assets/new-ui/gallery/place/Cyclop.png'
import Gigantos from '../assets/new-ui/gallery/place/Gigantos.png'
import Cronos from '../assets/new-ui/gallery/place/Cronos.png'
import Erini from '../assets/new-ui/gallery/place/Erini.png'
import Uranus from '../assets/new-ui/gallery/place/Uranus.png'

export const body = [
  {
    img: ZeusSkin,
    name: 'Zeus Skin',
    rarity: 'UNIQUE'
  },
  {
    img: HadesSkin,
    name: 'Hades Skin',
    rarity: 'UNIQUE'
  },
  {
    img: ApolloSkin,
    name: 'Apollo Skin',
    rarity: 'UNIQUE'
  },
  {
    img: PoseidonSkin,
    name: 'Poseidon Skin',
    rarity: 'UNIQUE'
  },
  {
    img: HephaestusSkin,
    name: 'Hephaestus Skin',
    rarity: 'UNIQUE'
  },
  {
    img: AphroditeSkin,
    name: 'Aphrodite Skin',
    rarity: 'UNIQUE'
  },
  {
    img: HermesSkin,
    name: 'Hermes Skin',
    rarity: 'UNIQUE'
  },
  {
    img: AresSkin,
    name: 'Ares Skin',
    rarity: 'UNIQUE'
  },
  {
    img: AthenaSkin,
    name: 'Athena Skin',
    rarity: 'UNIQUE'
  },
  {
    img: CosmicEnergy,
    name: 'Cosmic Energy',
    rarity: 'MYTHIC'
  },
  {
    img: IceEnergy,
    name: 'Ice Energy',
    rarity: 'MYTHIC'
  },
  {
    img: NebulaEnergy,
    name: 'Nebula Energy',
    rarity: 'MYTHIC'
  },
  {
    img: SteelEnergy,
    name: 'Steel Energy',
    rarity: 'MYTHIC'
  },
  {
    img: WaterEnergy,
    name: 'Water Energy',
    rarity: 'LEGENDARY'
  },
  {
    img: FairyEnergy,
    name: 'Fairy Energy',
    rarity: 'LEGENDARY'
  },
  {
    img: GhostEnergy,
    name: 'Ghost Energy',
    rarity: 'LEGENDARY'
  },
  {
    img: FireEnergy,
    name: 'Fire Energy',
    rarity: 'LEGENDARY'
  },
  {
    img: DarkEnergy,
    name: 'Dark Energy',
    rarity: 'LEGENDARY'
  },
  {
    img: GrassEnergy,
    name: 'Grass Energy',
    rarity: 'LEGENDARY'
  },
  {
    img: PoisonEnergy,
    name: 'Poison Energy',
    rarity: 'LEGENDARY'
  },
  {
    img: RockEnergy,
    name: 'Rock Energy',
    rarity: 'LEGENDARY'
  },
  {
    img: HollowEnergy,
    name: 'Hollow Energy',
    rarity: 'LEGENDARY'
  },

  {
    img: LightningEnergy,
    name: 'Lightning Energy',
    rarity: 'LEGENDARY'
  },
  {
    img: PrismEnergy,
    name: 'Prism Energy',
    rarity: 'LEGENDARY'
  },
  {
    img: Metal,
    name: 'Metal',
    rarity: 'EPIC'
  },
  {
    img: Bronze,
    name: 'Bronze',
    rarity: 'EPIC'
  },
  {
    img: Gold,
    name: 'Gold',
    rarity: 'EPIC'
  },
  {
    img: Silver,
    name: 'Silver',
    rarity: 'EPIC'
  },
  {
    img: Franken,
    name: 'Franken',
    rarity: 'RARE'
  },
  {
    img: Vampire,
    name: 'Vampire',
    rarity: 'RARE'
  },
  {
    img: Zombie,
    name: 'Zombie',
    rarity: 'RARE'
  },
  {
    img: Tiger,
    name: 'Tiger',
    rarity: 'COMMON'
  },
  {
    img: Dragon,
    name: 'Dragon',
    rarity: 'COMMON'
  },
  {
    img: Zebra,
    name: 'Zebra',
    rarity: 'COMMON'
  },
  {
    img: BumbleBee,
    name: 'Bumble Bee',
    rarity: 'COMMON'
  },
  {
    img: Denim,
    name: 'Denim',
    rarity: 'COMMON'
  },
  {
    img: Cyborg,
    name: 'Cyborg',
    rarity: 'COMMON'
  },
  {
    img: GreenAvocado,
    name: 'Green Avocado',
    rarity: 'COMMON'
  },
  {
    img: LimeGreen,
    name: 'Lime Green',
    rarity: 'COMMON'
  },
  {
    img: LightPurple,
    name: 'Light Purple',
    rarity: 'COMMON'
  },
  {
    img: Yellow,
    name: 'Yellow',
    rarity: 'COMMON'
  },
  {
    img: Tangerine,
    name: 'Tangerine',
    rarity: 'COMMON'
  },
  {
    img: LightPink,
    name: 'Light Pink',
    rarity: 'COMMON'
  },
  {
    img: NeonPink,
    name: 'Neon Pink',
    rarity: 'COMMON'
  },
  {
    img: Tanned,
    name: 'Tanned',
    rarity: 'COMMON'
  },
  {
    img: AppleRed,
    name: 'Apple Red',
    rarity: 'COMMON'
  },
  {
    img: Brown,
    name: 'Brown',
    rarity: 'COMMON'
  },
  {
    img: Blue,
    name: 'Blue',
    rarity: 'COMMON'
  },
  {
    img: LightBlue,
    name: 'Light Blue',
    rarity: 'COMMON'
  },
  {
    img: Basic,
    name: 'Basic',
    rarity: 'COMMON'
  },
]

export const accessories = [
  {
    img: Chain,
    name: 'Chain',
    rarity: 'MYTHIC'
  },
  {
    img: FangedInjury,
    name: 'Fanged Injury',
    rarity: 'MYTHIC'
  },
  {
    img: RainDoll,
    name: 'Rain Doll',
    rarity: 'MYTHIC'
  },
  {
    img: FinonFire,
    name: 'Fin on Fire',
    rarity: 'MYTHIC'
  },
  {
    img: RainDoll2,
    name: 'Rain Doll 2',
    rarity: 'LEGENDARY'
  },
  {
    img: Starfall,
    name: 'Starfall',
    rarity: 'LEGENDARY'
  },
  {
    img: Bandage,
    name: 'Bandage',
    rarity: 'LEGENDARY'
  },
  {
    img: Snake,
    name: 'Snake',
    rarity: 'LEGENDARY'
  },
  {
    img: Scars,
    name: 'Scars',
    rarity: 'EPIC'
  },
  {
    img: ShinyPearls,
    name: 'Shiny Pearls',
    rarity: 'EPIC'
  },
  {
    img: SilverRings,
    name: 'Silver Rings',
    rarity: 'EPIC'
  },
  {
    img: BasicGoldRing,
    name: 'Basic Gold Ring',
    rarity: 'RARE'
  },
  {
    img: Seaweed,
    name: 'Seaweed',
    rarity: 'RARE'
  },
  {
    img: PunkFin,
    name: 'Punk Fin',
    rarity: 'RARE'
  },
  {
    img: None,
    name: 'None',
    rarity: 'COMMON'
  },
]

export const headwear = [
  {
    img: PoseidonCrown,
    name: 'Poseidon Crown',
    rarity: 'UNIQUE'
  },
  {
    img: HadesFlamingHair,
    name: 'Hades Flaming<br/>Hair',
    rarity: 'UNIQUE'
  },
  {
    img: AphroditeFloralWreath,
    name: 'Aphrodite<br/>FloralWreath',
    rarity: 'UNIQUE'
  },
  {
    img: ApolloLyreCrown,
    name: 'Apollo Lyre Crown',
    rarity: 'UNIQUE'
  },
  {
    img: HephaestusBlacksmithHeadBand,
    name: 'Hephaestus<br/>Blacksmith<br/>Head Band',
    rarity: 'UNIQUE'
  },
  {
    img: ZeusLaurelWreath,
    name: 'Zeus Laurel Wreath',
    rarity: 'UNIQUE'
  },
  {
    img: AresSpartanHelmet,
    name: 'Ares Spartan<br/>Helmet',
    rarity: 'UNIQUE'
  },
  {
    img: AthenaCorinthianHelmet,
    name: 'Athena<br/>Corinthian Helmet',
    rarity: 'UNIQUE'
  },
  {
    img: HermesWingedHelmet,
    name: 'Hermes<br/>Winged Helmet',
    rarity: 'UNIQUE'
  },
  {
    img: Angel,
    name: 'Angel',
    rarity: 'UNIQUE'
  },
  {
    img: BirdNest,
    name: 'Bird Nest',
    rarity: 'MYTHIC'
  },
  {
    img: Headphone,
    name: 'Headphone',
    rarity: 'MYTHIC'
  },
  {
    img: MonkeyHeadwear,
    name: 'Monkey Headwear',
    rarity: 'MYTHIC'
  },
  {
    img: BeastHeadband,
    name: 'Beast Headband',
    rarity: 'MYTHIC'
  },
  {
    img: NonLa,
    name: 'Non La',
    rarity: 'LEGENDARY'
  },
  {
    img: RamenCap,
    name: 'Ramen Cap',
    rarity: 'LEGENDARY'
  },
  {
    img: Pilot,
    name: 'Pilot',
    rarity: 'LEGENDARY'
  },
  {
    img: MickeyHeadband,
    name: 'Mickey Headband',
    rarity: 'LEGENDARY'
  },
  {
    img: DemonHeadband,
    name: 'Demon Headband',
    rarity: 'LEGENDARY'
  },
  {
    img: UFO,
    name: 'UFO',
    rarity: 'LEGENDARY'
  },
  {
    img: NativeAmericans,
    name: 'Native Americans',
    rarity: 'LEGENDARY'
  },
  {
    img: Pinwheel,
    name: 'Pinwheel',
    rarity: 'LEGENDARY'
  },
  {
    img: FrogHeadband,
    name: 'Frog Headband',
    rarity: 'LEGENDARY'
  },
  {
    img: Turban,
    name: 'Turban',
    rarity: 'LEGENDARY'
  },
  {
    img: SpaHead,
    name: 'Spa Head',
    rarity: 'EPIC'
  },
  {
    img: BunnyHeadband,
    name: 'Bunny Headband',
    rarity: 'EPIC'
  },
  {
    img: ChickHat,
    name: 'Chick Hat',
    rarity: 'EPIC'
  },
  {
    img: PirateHat,
    name: 'Pirate Hat',
    rarity: 'EPIC'
  },
  {
    img: RedHood,
    name: 'Red Hood',
    rarity: 'EPIC'
  },
  {
    img: ClownHat,
    name: 'Clown Hat',
    rarity: 'EPIC'
  },
  {
    img: Medusa,
    name: 'Medusa',
    rarity: 'EPIC'
  },
  {
    img: NurseHat,
    name: 'Nurse Hat',
    rarity: 'EPIC'
  },
  {
    img: WizardHat,
    name: 'Wizard Hat',
    rarity: 'EPIC'
  },
  {
    img: Braids,
    name: 'Braids',
    rarity: 'EPIC'
  },
  {
    img: VikingHelmet,
    name: 'Viking Helmet',
    rarity: 'EPIC'
  },
  {
    img: MusketeerHat,
    name: 'Musketeer Hat',
    rarity: 'EPIC'
  },
  {
    img: BirthdayHat,
    name: 'Birthday Hat',
    rarity: 'EPIC'
  },
  {
    img: DaisyWreath,
    name: 'Daisy Wreath',
    rarity: 'EPIC'
  },
  {
    img: ChefHat,
    name: 'Chef Hat',
    rarity: 'EPIC'
  },
  {
    img: WinterHat,
    name: 'Winter Hat',
    rarity: 'EPIC'
  },
  {
    img: KingsCrown,
    name: 'Kings Crown',
    rarity: 'RARE'
  },
  {
    img: SherlockHolmesHat,
    name: 'Sherlock Holmes<br/>Hat',
    rarity: 'RARE'
  },
  {
    img: RobinHat,
    name: 'Robin Hat',
    rarity: 'RARE'
  },
  {
    img: SantaHat,
    name: 'Santa Hat',
    rarity: 'RARE'
  },
  {
    img: GoldCap,
    name: 'Gold Cap',
    rarity: 'RARE'
  },
  {
    img: SheriffsHat,
    name: 'Sheriffs Hat',
    rarity: 'RARE'
  },
  {
    img: Beret,
    name: 'Beret',
    rarity: 'RARE'
  },
  {
    img: YellowBucket,
    name: 'Yellow Bucket',
    rarity: 'COMMON'
  },
  {
    img: GreenBucket,
    name: 'Green Bucket',
    rarity: 'COMMON'
  },
  {
    img: RedCap,
    name: 'Red Cap',
    rarity: 'COMMON'
  },
  {
    img: FloweryRedBucket,
    name: 'Flowery Red Bucket',
    rarity: 'COMMON'
  },
  {
    img: GraduationHat,
    name: 'Graduation Hat',
    rarity: 'COMMON'
  },
  {
    img: MagicianHat,
    name: 'Magician Hat',
    rarity: 'COMMON'
  },
  {
    img: None,
    name: 'None',
    rarity: 'COMMON'
  },
]

export const necklace = [
  {
    img: RedScarf,
    name: 'Red Scarf',
    rarity: 'MYTHIC'
  },
  {
    img: SilverRim,
    name: 'Silver Rim',
    rarity: 'MYTHIC'
  },
  {
    img: GoldRings,
    name: 'Gold Rings',
    rarity: 'MYTHIC'
  },
  {
    img: GoldRim,
    name: 'Gold Rim',
    rarity: 'MYTHIC'
  },
  {
    img: BasicChoker,
    name: 'Basic Choker',
    rarity: 'LEGENDARY'
  },
  {
    img: Cravat,
    name: 'Cravat',
    rarity: 'LEGENDARY'
  },
  {
    img: PunkChoker,
    name: 'Punk Choker',
    rarity: 'LEGENDARY'
  },
  {
    img: CatBell,
    name: 'Cat Bell',
    rarity: 'LEGENDARY'
  },
  {
    img: Diamond,
    name: 'Diamond',
    rarity: 'LEGENDARY'
  },
  {
    img: GoldLeaf,
    name: 'Gold Leaf',
    rarity: 'LEGENDARY'
  },
  {
    img: Bell,
    name: 'Bell',
    rarity: 'EPIC'
  },
  {
    img: Bow,
    name: 'Bow',
    rarity: 'EPIC'
  },
  {
    img: Cross,
    name: 'Cross',
    rarity: 'EPIC'
  },
  {
    img: Fang,
    name: 'Fang',
    rarity: 'EPIC'
  },
  {
    img: GoldChain,
    name: 'Gold Chain',
    rarity: 'EPIC'
  },
  {
    img: Pearls,
    name: 'Pearls',
    rarity: 'EPIC'
  },
  {
    img: SilverChain,
    name: 'Silver Chain',
    rarity: 'RARE'
  },
  {
    img: Sunflower,
    name: 'Sunflower',
    rarity: 'RARE'
  },
  {
    img: GoldenEye,
    name: 'Golden Eye',
    rarity: 'COMMON'
  },
  {
    img: Skull,
    name: 'Skull',
    rarity: 'COMMON'
  },
  {
    img: Heart,
    name: 'Heart',
    rarity: 'COMMON'
  },
  {
    img: None,
    name: 'None',
    rarity: 'COMMON'
  },
]

export const bracelets = [
  {
    img: ApolloWristwear,
    name: 'Apollo Wristwear',
    rarity: 'UNIQUE'
  },
  {
    img: AthenaWristwear,
    name: 'Athena Wristwear',
    rarity: 'UNIQUE'
  },
  {
    img: HadesWristwear,
    name: 'Hades Wristwear',
    rarity: 'UNIQUE'
  },
  {
    img: ZeusWristwear,
    name: 'Zeus Wristwear',
    rarity: 'UNIQUE'
  },
  {
    img: HephaestusWristwear,
    name: 'Hephaestus<br/>Wristwear',
    rarity: 'UNIQUE'
  },
  {
    img: HermesWristwear,
    name: 'Hermes Wristwear',
    rarity: 'UNIQUE'
  },
  {
    img: PoseidonWristwear,
    name: 'Poseidon Wristwear',
    rarity: 'UNIQUE'
  },
  {
    img: AphroditeWristwear,
    name: 'Aphrodite Wristwear',
    rarity: 'UNIQUE'
  },
  {
    img: AresWristwear,
    name: 'Ares Wristwear',
    rarity: 'UNIQUE'
  },
  {
    img: TechClaws,
    name: 'Tech-Claws',
    rarity: 'MYTHIC'
  },
  {
    img: BeastClaws,
    name: 'Beast Claws',
    rarity: 'MYTHIC'
  },
  {
    img: BoxingGloves,
    name: 'Boxing Gloves',
    rarity: 'LEGENDARY'
  },
  {
    img: SpikyBracelet,
    name: 'Spiky Bracelet',
    rarity: 'LEGENDARY'
  },
  {
    img: CheerleadingPomPom,
    name: 'Cheerleading<br/>Pom Pom',
    rarity: 'LEGENDARY'
  },
  {
    img: CrabClaws,
    name: 'Crab Claws',
    rarity: 'LEGENDARY'
  },
  {
    img: MartialArts,
    name: 'Martial Arts',
    rarity: 'LEGENDARY'
  },
  {
    img: HandGaltingGun,
    name: 'Hand Galting Gun',
    rarity: 'EPIC'
  },
  {
    img: PirateHook,
    name: 'Pirate Hook',
    rarity: 'EPIC'
  },
  {
    img: WolverineClaws,
    name: 'Wolverine Claws',
    rarity: 'EPIC'
  },
  {
    img: BasicBracelet,
    name: 'Basic Bracelet',
    rarity: 'RARE'
  },
  {
    img: Watch,
    name: 'Watch',
    rarity: 'RARE'
  },
  {
    img: Rosery,
    name: 'Rosery',
    rarity: 'RARE'
  },
  {
    img: None,
    name: 'None',
    rarity: 'COMMON'
  },
]

export const suit = [
  {
    img: ZeusCostume,
    name: 'Zeus Costume',
    rarity: 'UNIQUE'
  },
  {
    img: HermesCostume,
    name: 'Hermes Costume',
    rarity: 'UNIQUE'
  },
  {
    img: HephaestusCostume,
    name: 'Hephaestus<br/>Costume',
    rarity: 'UNIQUE'
  },
  {
    img: HadesCostume,
    name: 'Hades Costume',
    rarity: 'UNIQUE'
  },
  {
    img: PoseidonCostume,
    name: 'Poseidon Costume',
    rarity: 'UNIQUE'
  },
  {
    img: AthenaCostume,
    name: 'Athena Costume',
    rarity: 'UNIQUE'
  },
  {
    img: AresCostume,
    name: 'Ares Costume',
    rarity: 'UNIQUE'
  },
  {
    img: ApolloCostume,
    name: 'Apollo Costume',
    rarity: 'UNIQUE'
  },
  {
    img: AphroditeCostume,
    name: 'Aphrodite Costume',
    rarity: 'UNIQUE'
  },
  {
    img: TechSuit,
    name: 'Tech Suit',
    rarity: 'MYTHIC'
  },
  {
    img: Oni,
    name: 'Oni',
    rarity: 'MYTHIC'
  },
  {
    img: Jiangshi,
    name: 'Jiangshi',
    rarity: 'MYTHIC'
  },
  {
    img: VampireJacket,
    name: 'Vampire Jacket',
    rarity: 'MYTHIC'
  },
  {
    img: MartialArtsUniforms,
    name: 'Martial Arts<br/>Uniforms',
    rarity: 'MYTHIC'
  },
  {
    img: Ninja,
    name: 'Ninja',
    rarity: 'MYTHIC'
  },
  {
    img: Pajamas,
    name: 'Pajamas',
    rarity: 'LEGENDARY'
  },
  {
    img: DuckyDress,
    name: 'Ducky Dress',
    rarity: 'LEGENDARY'
  },
  {
    img: Cheongsam,
    name: 'Cheongsam',
    rarity: 'LEGENDARY'
  },
  {
    img: OfficeBlazer,
    name: 'Office Blazer',
    rarity: 'LEGENDARY'
  },
  {
    img: Dungarees,
    name: 'Dungarees',
    rarity: 'LEGENDARY'
  },
  {
    img: Mummy,
    name: 'Mummy',
    rarity: 'LEGENDARY'
  },
  {
    img: BlackTuxedo,
    name: 'Black Tuxedo',
    rarity: 'LEGENDARY'
  },
  {
    img: RedTuxedo,
    name: 'Red Tuxedo',
    rarity: 'LEGENDARY'
  },
  {
    img: PunkBlazer,
    name: 'Punk Blazer',
    rarity: 'LEGENDARY'
  },
  {
    img: SakuraYukata,
    name: 'Sakura Yukata',
    rarity: 'LEGENDARY'
  },
  {
    img: BusinessSuit,
    name: 'Business Suit',
    rarity: 'LEGENDARY'
  },
  {
    img: BlackHoodie,
    name: 'Black Hoodie',
    rarity: 'LEGENDARY'
  },
  {
    img: BlueHoodie,
    name: 'Blue Hoodie',
    rarity: 'LEGENDARY'
  },
  {
    img: RedHoodie,
    name: 'Red Hoodie',
    rarity: 'LEGENDARY'
  },
  {
    img: SportUniform,
    name: 'Sport Uniform',
    rarity: 'EPIC'
  },
  {
    img: SwimsuitBikini,
    name: 'Swimsuit Bikini',
    rarity: 'EPIC'
  },
  {
    img: SwimsuitSport,
    name: 'Swimsuit Sport',
    rarity: 'EPIC'
  },
  {
    img: Caveshark,
    name: 'Caveshark',
    rarity: 'EPIC'
  },
  {
    img: YellowRaincoat,
    name: 'Yellow Raincoat',
    rarity: 'EPIC'
  },
  {
    img: BluePoloShirt,
    name: 'Blue Polo Shirt',
    rarity: 'RARE'
  },
  {
    img: RedPoloShirt,
    name: 'Red Polo Shirt',
    rarity: 'RARE'
  },
  {
    img: Tarzan,
    name: 'Tarzan',
    rarity: 'RARE'
  },
  {
    img: Loincloth,
    name: 'Loincloth',
    rarity: 'RARE'
  },
  {
    img: WhiteTShirt,
    name: 'White T-shirt',
    rarity: 'COMMON'
  },
  {
    img: YellowTShirt,
    name: 'Yellow T-shirt',
    rarity: 'COMMON'
  },
  {
    img: None,
    name: 'None',
    rarity: 'COMMON'
  },
]

export const glasses = [
  {
    img: CyclopsEyeshield,
    name: 'Cyclops Eyeshield',
    rarity: 'UNIQUE'
  },
  {
    img: VRHeadset,
    name: 'VR Headset',
    rarity: 'MYTHIC'
  },
  {
    img: Monocle,
    name: 'Monocle',
    rarity: 'MYTHIC'
  },
  {
    img: PunkSunglasses,
    name: 'Punk Sunglasses',
    rarity: 'MYTHIC'
  },
  {
    img: FuturisticSunglasses,
    name: 'Futuristic<br/>Sunglasses',
    rarity: 'MYTHIC'
  },
  {
    img: ThreeDGlasses,
    name: '3D Glasses',
    rarity: 'MYTHIC'
  },
  {
    img: ScubaEyeshield,
    name: 'Scuba Eyeshield',
    rarity: 'LEGENDARY'
  },
  {
    img: YellowBlindfolds,
    name: 'Yellow Blindfolds',
    rarity: 'LEGENDARY'
  },
  {
    img: PirateEyepatch,
    name: 'Pirate Eyepatch',
    rarity: 'LEGENDARY'
  },
  {
    img: PineappleSunglassed,
    name: 'Pineapple Sunglassed',
    rarity: 'LEGENDARY'
  },
  {
    img: PixelSunglasses,
    name: 'Pixel Sunglasses',
    rarity: 'LEGENDARY'
  },
  {
    img: StarSunglasses,
    name: 'Star Sunglasses',
    rarity: 'EPIC'
  },
  {
    img: DiscoGlasses,
    name: 'Disco Glasses',
    rarity: 'EPIC'
  },
  {
    img: HeartSunglasses,
    name: 'Heart Sunglasses',
    rarity: 'EPIC'
  },
  {
    img: IncredibleMask,
    name: 'Incredible Mask',
    rarity: 'EPIC'
  },
  {
    img: BlindGlasses,
    name: 'Blind Glasses',
    rarity: 'EPIC'
  },
  {
    img: HypnoGlasses,
    name: 'Hypno Glasses',
    rarity: 'EPIC'
  },
  {
    img: SunflowerSunglasses,
    name: 'Sunflower<br/>Sunglasses',
    rarity: 'EPIC'
  },
  {
    img: ReptileEyeglasses,
    name: 'Reptile Eyeglasses',
    rarity: 'EPIC'
  },
  {
    img: CatEyeSunglasses,
    name: 'Cat EyeS unglasses',
    rarity: 'RARE'
  },
  {
    img: WhiteSunglasses,
    name: 'White Sunglasses',
    rarity: 'RARE'
  },
  {
    img: BeachSunglasses,
    name: 'Beach Sunglasses',
    rarity: 'RARE'
  },
  {
    img: BasicGlasses,
    name: 'Basic Glasses',
    rarity: 'COMMON'
  },
  {
    img: NerdGlasses,
    name: 'Nerd Glasses',
    rarity: 'COMMON'
  },
  {
    img: None,
    name: 'None',
    rarity: 'COMMON'
  },
]

export const wings = [
  {
    img: HadesWings,
    name: 'Hades Wings',
    rarity: 'UNIQUE'
  },
  {
    img: PoseidonWings,
    name: 'Poseidon Wings',
    rarity: 'UNIQUE'
  },
  {
    img: AresWings,
    name: 'Ares Wings',
    rarity: 'UNIQUE'
  },
  {
    img: ApolloWings,
    name: 'Apollo Wings',
    rarity: 'UNIQUE'
  },
  {
    img: HermesWings,
    name: 'Hermes Wings',
    rarity: 'UNIQUE'
  },
  {
    img: AthenaWings,
    name: 'Athena Wings',
    rarity: 'UNIQUE'
  },
  {
    img: AphroditeWings,
    name: 'Aphrodite Wings',
    rarity: 'UNIQUE'
  },
  {
    img: HephaestusWings,
    name: 'Hephaestus Wings',
    rarity: 'UNIQUE'
  },
  {
    img: ZeusWings,
    name: 'Zeus Wings',
    rarity: 'UNIQUE'
  },
  {
    img: DemonWings,
    name: 'Demon Wings',
    rarity: 'MYTHIC'
  },
  {
    img: BatWings,
    name: 'Bat Wings',
    rarity: 'MYTHIC'
  },
  {
    img: DragonWings,
    name: 'Dragon Wings',
    rarity: 'MYTHIC'
  },
  {
    img: OrangeBlueFairyWings,
    name: 'Orange Blue<br/>Fairy Wings',
    rarity: 'LEGENDARY'
  },
  {
    img: WhiteBlueFairyWings,
    name: 'White Blue<br/>Fairy Wings',
    rarity: 'LEGENDARY'
  },
  {
    img: BlueButterfly,
    name: 'Blue Butterfly',
    rarity: 'LEGENDARY'
  },
  {
    img: YellowButterfly,
    name: 'Yellow Butterfly',
    rarity: 'LEGENDARY'
  },
  {
    img: DragonflyWings,
    name: 'Dragonfly Wings',
    rarity: 'LEGENDARY'
  },
  {
    img: AngelWings,
    name: 'Angel Wings',
    rarity: 'LEGENDARY'
  },
  {
    img: None,
    name: 'None',
    rarity: 'COMMON'
  },
]

export const weapon = [
  {
    img: ZeusLightningBlade,
    name: 'Zeus Lightning<br/>Blade',
    rarity: 'UNIQUE'
  },
  {
    img: PoseidonKingTrident,
    name: 'Poseidon King<br/>Trident',
    rarity: 'UNIQUE'
  },
  {
    img: HadesHellishLamp,
    name: 'Hades Hellish Lamp',
    rarity: 'UNIQUE'
  },
  {
    img: AresInfernoWar,
    name: 'Ares Inferno War',
    rarity: 'UNIQUE'
  },
  {
    img: ApolloGoldenBow,
    name: 'Apollo Golden Bow',
    rarity: 'UNIQUE'
  },
  {
    img: HermesNomadStick,
    name: 'Hermes Nomad<br/>Stick',
    rarity: 'UNIQUE'
  },
  {
    img: AthenaAmazonSpear,
    name: 'Athena Amazon<br/>Spear',
    rarity: 'UNIQUE'
  },
  {
    img: AphroditeStick,
    name: 'Aphrodite Stick',
    rarity: 'UNIQUE'
  },
  {
    img: HephaestusForgeHammer,
    name: 'Hephaestus Forge<br/>Hammer',
    rarity: 'UNIQUE'
  },
  {
    img: FlamingAx,
    name: 'Flaming Ax',
    rarity: 'MYTHIC'
  },
  {
    img: FlamingSword,
    name: 'Flaming Sword',
    rarity: 'MYTHIC'
  },
  {
    img: FlamingCrescentBlade,
    name: 'Flaming Crescent<br/>Blade',
    rarity: 'MYTHIC'
  },
  {
    img: FlamingArrows,
    name: 'Flaming Arrows',
    rarity: 'MYTHIC'
  },
  {
    img: FrozenSword,
    name: 'Frozen Sword',
    rarity: 'LEGENDARY'
  },
  {
    img: FrozenCrescentBlade,
    name: 'Frozen Crescent<br/>Blade',
    rarity: 'LEGENDARY'
  },
  {
    img: FrozenAx,
    name: 'Frozen Ax',
    rarity: 'LEGENDARY'
  },
  {
    img: HellishSickle,
    name: 'Hellish Sickle',
    rarity: 'LEGENDARY'
  },
  {
    img: PoisonArrows,
    name: 'Poison Arrows',
    rarity: 'LEGENDARY'
  },
  {
    img: GiantAx,
    name: 'Giant Ax',
    rarity: 'EPIC'
  },
  {
    img: DualBlades,
    name: 'Dual Blades',
    rarity: 'EPIC'
  },
  {
    img: GiantShuriken,
    name: 'Giant Shuriken',
    rarity: 'EPIC'
  },
  {
    img: Kunai,
    name: 'Kunai',
    rarity: 'EPIC'
  },
  {
    img: Scythe,
    name: 'Scythe',
    rarity: 'EPIC'
  },
  {
    img: SpikyMace,
    name: 'Spiky Mace',
    rarity: 'RARE'
  },
  {
    img: SteelAx,
    name: 'Steel Ax',
    rarity: 'RARE'
  },
  {
    img: SteelCrescentBlade,
    name: 'Steel Crescent<br/>Blade',
    rarity: 'RARE'
  },
  {
    img: SteelSword,
    name: 'Steel<br/>Sword',
    rarity: 'RARE'
  },
  {
    img: WoodenArrows,
    name: 'Wooden Arrows',
    rarity: 'RARE'
  },
  {
    img: None,
    name: 'None',
    rarity: 'COMMON'
  },
]

export const eyes = [
  {
    img: AphroditeEyes,
    name: 'Aphrodite Eyes',
    rarity: 'UNIQUE'
  },
  {
    img: ApolloEyes,
    name: 'Apollo Eyes',
    rarity: 'UNIQUE'
  },
  {
    img: AresEyes,
    name: 'Ares Eyes',
    rarity: 'UNIQUE'
  },
  {
    img: AthenaEyes,
    name: 'Athena Eyes',
    rarity: 'UNIQUE'
  },
  {
    img: HadesEyes,
    name: 'Hades Eyes',
    rarity: 'UNIQUE'
  },
  {
    img: HephaestusEyes,
    name: 'Hephaestus Eyes',
    rarity: 'UNIQUE'
  },
  {
    img: HermesEyes,
    name: 'Hermes Eyes',
    rarity: 'UNIQUE'
  },
  {
    img: PoseidonEyes,
    name: 'Poseidon Eyes',
    rarity: 'UNIQUE'
  },
  {
    img: ZeusEyes,
    name: 'Zeus Eyes',
    rarity: 'UNIQUE'
  },
  {
    img: PossessedEyes,
    name: 'Possessed Eyes',
    rarity: 'UNIQUE'
  },
  {
    img: InflamedEyes,
    name: 'Inflamed Eyes',
    rarity: 'UNIQUE'
  },
  {
    img: LazerEyes,
    name: 'Lazer Eyes',
    rarity: 'UNIQUE'
  },
  {
    img: AlienEyes,
    name: 'Alien Eyes',
    rarity: 'MYTHIC'
  },
  {
    img: DiamondEyes,
    name: 'Diamond Eyes',
    rarity: 'MYTHIC'
  },
  {
    img: OutragedEyes,
    name: 'Outraged Eyes',
    rarity: 'MYTHIC'
  },
  {
    img: GreedyEyes,
    name: 'Greedy Eyes',
    rarity: 'MYTHIC'
  },
  {
    img: ButtonEyes,
    name: 'Button Eyes',
    rarity: 'LEGENDARY'
  },
  {
    img: BeautifulEyes,
    name: 'Beautiful Eyes',
    rarity: 'LEGENDARY'
  },
  {
    img: HeartyEyes,
    name: 'Hearty Eyes',
    rarity: 'LEGENDARY'
  },
  {
    img: ReptileEyes,
    name: 'Reptile Eyes',
    rarity: 'LEGENDARY'
  },
  {
    img: LollipopEyes,
    name: 'Lollipop Eyes',
    rarity: 'LEGENDARY'
  },
  {
    img: AngryEyes,
    name: 'Angry Eyes',
    rarity: 'EPIC'
  },
  {
    img: DeadEyes,
    name: 'Dead Eyes',
    rarity: 'EPIC'
  },
  {
    img: ExpressionlessEyes,
    name: 'Expressionless Eyes',
    rarity: 'EPIC'
  },
  {
    img: BeggingEyes,
    name: 'Begging Eyes',
    rarity: 'EPIC'
  },
  {
    img: SleeplessEyes,
    name: 'Sleepless Eyes',
    rarity: 'EPIC'
  },
  {
    img: SkepticalEyes,
    name: 'Skeptical Eyes',
    rarity: 'EPIC'
  },
  {
    img: TearyEyes,
    name: 'Teary Eyes',
    rarity: 'EPIC'
  },
  {
    img: AnnoyedEyes,
    name: 'Annoyed Eyes',
    rarity: 'EPIC'
  },
  {
    img: DizzyEyes,
    name: 'Dizzy Eyes',
    rarity: 'EPIC'
  },
  {
    img: CrazyEyes,
    name: 'Crazy Eyes',
    rarity: 'RARE'
  },
  {
    img: EyelashEyes,
    name: 'Eyelash Eyes',
    rarity: 'RARE'
  },
  {
    img: SadEyes,
    name: 'Sad Eyes',
    rarity: 'RARE'
  },
  {
    img: SmileyEyes,
    name: 'Smiley Eyes',
    rarity: 'COMMON'
  },
  {
    img: StupidEyes,
    name: 'Stupid Eyes',
    rarity: 'COMMON'
  },
  {
    img: SurprisedEyes,
    name: 'Surprised Eyes',
    rarity: 'COMMON'
  },
  {
    img: CloseTightEyes,
    name: 'Close Tight Eyes',
    rarity: 'COMMON'
  },
  {
    img: XXEyes,
    name: 'XX Eyes',
    rarity: 'COMMON'
  },
  {
    img: NormalEyes,
    name: 'Normal Eyes',
    rarity: 'COMMON'
  },
  {
    img: TinyEyes,
    name: 'Tiny Eyes',
    rarity: 'COMMON'
  },
]

export const mouth = [
  {
    img: AresMouth,
    name: 'Ares Mouth',
    rarity: 'UNIQUE'
  },
  {
    img: AthenaMouth,
    name: 'Athena Mouth',
    rarity: 'UNIQUE'
  },
  {
    img: HadesMouth,
    name: 'Hades Mouth',
    rarity: 'UNIQUE'
  },
  {
    img: HephaestusMouth,
    name: 'Hephaestus Mouth',
    rarity: 'UNIQUE'
  },
  {
    img: HermesMouth,
    name: 'Hermes Mouth',
    rarity: 'UNIQUE'
  },
  {
    img: PoseidonMouth,
    name: 'Poseidon Mouth',
    rarity: 'UNIQUE'
  },
  {
    img: ZeusMouth,
    name: 'Zeus Mouth',
    rarity: 'UNIQUE'
  },
  {
    img: AphroditeMouth,
    name: 'Aphrodite Mouth',
    rarity: 'UNIQUE'
  },
  {
    img: ApolloMouth,
    name: 'Apollo Mouth',
    rarity: 'UNIQUE'
  },
  {
    img: DroolingJaw,
    name: 'Drooling Jaw',
    rarity: 'MYTHIC'
  },
  {
    img: Smoking,
    name: 'Smoking',
    rarity: 'MYTHIC'
  },
  {
    img: Grillz,
    name: 'Grillz',
    rarity: 'MYTHIC'
  },
  {
    img: BabyJaw,
    name: 'Baby Jaw',
    rarity: 'MYTHIC'
  },
  {
    img: Eating,
    name: 'Eating',
    rarity: 'MYTHIC'
  },
  {
    img: BubbleGum,
    name: 'Bubble Gum',
    rarity: 'MYTHIC'
  },
  {
    img: Braces,
    name: 'Braces',
    rarity: 'MYTHIC'
  },
  {
    img: TurbanMask,
    name: 'Turban Mask',
    rarity: 'LEGENDARY'
  },
  {
    img: Beak,
    name: 'Beak',
    rarity: 'LEGENDARY'
  },
  {
    img: AftermealJaw,
    name: 'Aftermeal Jaw',
    rarity: 'LEGENDARY'
  },
  {
    img: BloodyJaw,
    name: 'Bloody Jaw',
    rarity: 'LEGENDARY'
  },
  {
    img: Meh,
    name: 'Meh',
    rarity: 'LEGENDARY'
  },
  {
    img: NaughtySmile,
    name: 'Naughty Smile',
    rarity: 'LEGENDARY'
  },
  {
    img: NastySmile,
    name: 'Nasty Smile',
    rarity: 'LEGENDARY'
  },
  {
    img: Smile,
    name: 'Smile',
    rarity: 'EPIC'
  },
  {
    img: MustacheJaw,
    name: 'Mustache Jaw',
    rarity: 'EPIC'
  },
  {
    img: ToothlessSmile,
    name: 'Toothless Smile',
    rarity: 'EPIC'
  },
  {
    img: Lipstick,
    name: 'Lipstick',
    rarity: 'EPIC'
  },
  {
    img: Surprised,
    name: 'Surprised',
    rarity: 'RARE'
  },
  {
    img: Sad,
    name: 'Sad',
    rarity: 'RARE'
  },
  {
    img: UwUSmile,
    name: 'UwU Smile',
    rarity: 'RARE'
  },
  {
    img: HappySmile,
    name: 'Happy Smile',
    rarity: 'COMMON'
  },
  {
    img: NormalJaw,
    name: 'Normal Jaw',
    rarity: 'COMMON'
  },
]

export const tail = [
  {
    img: HadesTail,
    name: 'Hades Tail',
    rarity: 'UNIQUE'
  },
  {
    img: ZeusTail,
    name: 'Zeus Tail',
    rarity: 'UNIQUE'
  },
  {
    img: ApolloTail,
    name: 'Apollo Tail',
    rarity: 'UNIQUE'
  },
  {
    img: PoseidonTail,
    name: 'Poseidon Tail',
    rarity: 'UNIQUE'
  },
  {
    img: HermesTail,
    name: 'Hermes Tail',
    rarity: 'UNIQUE'
  },
  {
    img: AresTail,
    name: 'Ares Tail',
    rarity: 'UNIQUE'
  },
  {
    img: AthenaTail,
    name: 'Athena Tail',
    rarity: 'UNIQUE'
  },
  {
    img: AphroditeTail,
    name: 'Aphrodite Tail',
    rarity: 'UNIQUE'
  },
  {
    img: HephaestusTail,
    name: 'Hephaestus Tail',
    rarity: 'UNIQUE'
  },
  {
    img: Tentacles,
    name: 'Tentacles',
    rarity: 'MYTHIC'
  },
  {
    img: Gumiho,
    name: 'Gumiho',
    rarity: 'MYTHIC'
  },
  {
    img: Ghoul,
    name: 'Ghoul',
    rarity: 'MYTHIC'
  },
  {
    img: ShinyMermaidTail,
    name: 'Shiny Mermaid Tail',
    rarity: 'MYTHIC'
  },
  {
    img: BumbleBeeTail,
    name: 'Bumble Bee',
    rarity: 'MYTHIC'
  },
  {
    img: DemonicDragonTail,
    name: 'Demonic Dragon<br/>Tail',
    rarity: 'MYTHIC'
  },
  {
    img: Balloon,
    name: 'Balloon',
    rarity: 'MYTHIC'
  },
  {
    img: Donut,
    name: 'Donut',
    rarity: 'LEGENDARY'
  },
  {
    img: BandageTail,
    name: 'Bandage Tail',
    rarity: 'LEGENDARY'
  },
  {
    img: SnakeTail,
    name: 'Snake Tail',
    rarity: 'EPIC'
  },
  {
    img: MechaTail,
    name: 'Mecha Tail',
    rarity: 'EPIC'
  },
  {
    img: Diamonds,
    name: 'Diamonds',
    rarity: 'EPIC'
  },
  {
    img: GoldenRings,
    name: 'Gold Rings',
    rarity: 'EPIC'
  },
  {
    img: PunkTail,
    name: 'Punk Tail',
    rarity: 'EPIC'
  },
  {
    img: StabbedTail,
    name: 'Stabbed Tail',
    rarity: 'RARE'
  },
  {
    img: ChainedTail,
    name: 'Chained Tail',
    rarity: 'RARE'
  },
  {
    img: None,
    name: 'None',
    rarity: 'COMMON'
  },
]

export const shoes = [
  {
    img: PoseidonWave,
    name: 'Poseidon Wave',
    rarity: 'UNIQUE'
  },
  {
    img: ApolloSunBoots,
    name: 'Apollo Sun Boots',
    rarity: 'UNIQUE'
  },
  {
    img: AresCombatBoots,
    name: 'Ares Combat Boots',
    rarity: 'UNIQUE'
  },
  {
    img: HermesFlyingBoots,
    name: 'Hermes Flying<br/>Boots',
    rarity: 'UNIQUE'
  },
  {
    img: AthenaCombatBoots,
    name: 'Athena Combat<br/>Boots',
    rarity: 'UNIQUE'
  },
  {
    img: AphroditeSilkRibbon,
    name: 'Aphrodite Silk<br/>Ribbon',
    rarity: 'UNIQUE'
  },
  {
    img: HephaestusBlacksmithBoots,
    name: 'Hephaestus<br/>Blacksmith Boots',
    rarity: 'UNIQUE'
  },
  {
    img: ZeusFlyingNimbus,
    name: 'Zeus Flying Nimbus',
    rarity: 'UNIQUE'
  },
  {
    img: HadesSkullBoots,
    name: 'Hades Skull Boots',
    rarity: 'UNIQUE'
  },
  {
    img: TechBoots,
    name: 'Tech Boots',
    rarity: 'MYTHIC'
  },
  {
    img: PunkBoots,
    name: 'Punk Boots',
    rarity: 'MYTHIC'
  },
  {
    img: RedRollerskaters,
    name: 'Red Rollerskaters',
    rarity: 'MYTHIC'
  },
  {
    img: BeehieSlippers,
    name: 'Beehie Slippers',
    rarity: 'MYTHIC'
  },
  {
    img: BlueRollerskaters,
    name: 'Blue Rollerskaters',
    rarity: 'LEGENDARY'
  },
  {
    img: Skateboard,
    name: 'Skateboard',
    rarity: 'LEGENDARY'
  },
  {
    img: KungfuLoafer,
    name: 'Kungfu Loafer',
    rarity: 'LEGENDARY'
  },
  {
    img: MartialsArts,
    name: 'Martials Arts',
    rarity: 'LEGENDARY'
  },
  {
    img: Slippers,
    name: 'Slippers',
    rarity: 'LEGENDARY'
  },
  {
    img: WoodenClogs,
    name: 'Wooden Clogs',
    rarity: 'LEGENDARY'
  },
  {
    img: BlackSneaker,
    name: 'Black Sneaker',
    rarity: 'EPIC'
  },
  {
    img: RedSneaker,
    name: 'Red Sneaker',
    rarity: 'EPIC'
  },
  {
    img: DuckFeet,
    name: 'Duck Feet',
    rarity: 'EPIC'
  },
  {
    img: WarriorSandals,
    name: 'Warrior Sandals',
    rarity: 'EPIC'
  },
  {
    img: CowboyBoots,
    name: 'Cowboy Boots',
    rarity: 'RARE'
  },
  {
    img: RainBoots,
    name: 'Rain Boots',
    rarity: 'COMMON'
  },
  {
    img: WinterBoots,
    name: 'Winter Boots',
    rarity: 'COMMON'
  },
  {
    img: None,
    name: 'None',
    rarity: 'COMMON'
  },
]

export const place = [
  {
    img: MediterraneanSea,
    name: 'Mediterranean Sea',
    rarity: 'UNIQUE'
  },
  {
    img: OlympusPeak,
    name: 'Olympus Peak',
    rarity: 'UNIQUE'
  },
  {
    img: Tartarus,
    name: 'Tartarus',
    rarity: 'UNIQUE'
  },
  {
    img: PantheonTemple,
    name: 'Pantheon Temple',
    rarity: 'MYTHIC'
  },
  {
    img: Abyss,
    name: 'Abyss',
    rarity: 'MYTHIC'
  },
  {
    img: MilotIsland,
    name: 'Milot Island',
    rarity: 'MYTHIC'
  },
  {
    img: DelightIsland,
    name: 'Delight Island',
    rarity: 'MYTHIC'
  },
  {
    img: OrtrusMountain,
    name: 'Ortrus Mountain',
    rarity: 'MYTHIC'
  },
  {
    img: DenpherTemple,
    name: 'Denpher Temple',
    rarity: 'MYTHIC'
  },
  {
    img: Gaia,
    name: 'Gaia',
    rarity: 'COMMON'
  },
  {
    img: Nile,
    name: 'Nile',
    rarity: 'COMMON'
  },
  {
    img: Nin,
    name: 'Nin',
    rarity: 'COMMON'
  },
  {
    img: Boxphore,
    name: 'Boxphore',
    rarity: 'COMMON'
  },
  {
    img: Cyclop,
    name: 'Cyclop',
    rarity: 'COMMON'
  },
  {
    img: Gigantos,
    name: 'Gigantos',
    rarity: 'COMMON'
  },
  {
    img: Cronos,
    name: 'Cronos',
    rarity: 'COMMON'
  },
  {
    img: Erini,
    name: 'Erini',
    rarity: 'COMMON'
  },
  {
    img: Uranus,
    name: 'Uranus',
    rarity: 'COMMON'
  },
]